import type { ColumnDef } from "@tanstack/react-table";
import type { EnrichedProfitabilityPeriod } from "@/profitability/types";
import { RunStatus } from "./run-status";
export const statusCol: ColumnDef<EnrichedProfitabilityPeriod> = {
  id: "status",
  header: "Status",
  // Not sortable: the underlying values sort alphabetically into an order
  // that means nothing next to the labels shown.
  enableSorting: false,
  meta: { size: "190px" },
  cell: ({ row }) => <RunStatus run={row.original} />,
};
